module.exports = __webpack_public_path__ + "littienaga-d545f904.png";